import React from "react";
import { useNavigate } from "react-router-dom";
import ClientsSaySlider from "../component/ClientsSaySlider";
import FixHeader from "../component/FixHeader";
import LatestBlog from "../component/LatestBlog";
import Loader from "../component/Loader";
import Footer from "../component/Footer";
import Book from "../assets/images/about/book.png";
import Pen from "../assets/images/about/pen.png";
import AboutImg1 from "../assets/images/about/about-img1.png";
import Experienced from "../assets/images/svg/Experienced.svg";
import Certified from "../assets/images/svg/Certified.svg";
import Vision from "../assets/images/about/vision.png";
import VisionBoxImg from "../assets/images/about/vision-box-img.jpg";
import Mission from "../assets/images/about/mission.png";
import AboutImg5 from "../assets/images/about/about-img5.jpg";
import Union from "../assets/images/home/Union.png";


const About = () => {
  const navigate = useNavigate()
  return (
    <>
      <div className="site_contain">
        {/* <!-- ====================================== Preloader ===================================== --> */}
        <Loader />
        <FixHeader />
        {/* <!-- ====================================== About Section One ===================================== --> */}
        <section className="section-breadcrumb-img" id="about-section-one">
          <div className="container breadcrumb-main">
            <h1 className="about-h1-text" data-aos="fade-down">About</h1>
            <ul className="breadcrumb-list about-breadcrumb" data-aos="fade-up">
              <li className="line-slash" onClick={() => navigate("/")}>Home</li>
              <li className="line-slash" onClick={() => navigate("/About")}>Page</li>
              <li className="active-breadcrumb" onClick={() => navigate("/About")}>About</li>
            </ul>
          </div>
        </section>
        {/* <!-- ====================================== About Section Two ===================================== --> */}
        <section className="about-section-two">
          <div className="container overflow-hidden">
            <div className="row about-section-two-row">
              <div className="col-xxl-6 col-xl-6 col-lg-6 position-relative z-shape-woman">
                <img className="z-shape" src={Union} alt="Union" />
                <img className="about-img1" src={AboutImg1} alt="about-img1" />
                <img className="pen" src={Pen} alt="pen" />
                <img src={Book} className="book" alt="book" />
              </div>
              <div className="col-xxl-6 col-xl-6 col-lg-6">
                <h2 className="section-heading-text" data-aos="fade-up">
                  We Are <span>Content Writing</span> Since 2016
                </h2>
                <p className="section-sub-text since" data-aos="fade-up">
                  Ac quis pretium consectetur urna dolor. Cursus et amet neque ullamcorper. Cursus tempus accumsan eu nibh.
                </p>
                <div className="experienced-text-box experienced-text-box1">
                  <div className="svg-icon-main" data-aos="fade-up">
                    <img
                      className="svg-icon"
                      src={Experienced}
                      alt="Experienced"
                    />
                    <h3 className="experienced-text">Experienced</h3>
                  </div>
                  <p className="sitamet-text since" data-aos="fade-up">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor. bnfd Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                    eiusmod tempor.
                  </p>
                </div>
                <div className="experienced-text-box">
                  <div className="svg-icon-main" data-aos="fade-up">
                    <img className="svg-icon" src={Certified} alt="Certified" />
                    <h3 className="experienced-text">Certified</h3>
                  </div>
                  <p className="sitamet-text since" data-aos="fade-up">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor. bndf Lorem ipsum dolor sit amet,
                    consectetur adipiscing elit, sed do eiusmod tempor. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                    eiusmod tempor.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!-- ====================================== About Section Three ===================================== --> */}
        <section className="about-section-three">
          <div className="container">
            <div className="row">
              <div className="col-xxl-4 col-xl-4 col-lg-4 about-sec-col1 about-sec-col11 p-0">
                <div className="vision-box" data-aos="fade-up">
                  <img className="vision-icons" src={Vision} alt="vision" />
                  <h3 className="vision">Our Vision</h3>
                  <p className="sitamet-text sociis">
                    Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa cum sociis
                    natoque.
                  </p>
                </div>
              </div>
              <div className="col-xxl-4 col-xl-4 col-lg-4 about-sec-col p-0">
                <img
                  className="vision-box-img"
                  data-aos="fade-up"
                  src={VisionBoxImg}
                  alt="vision-box-img"
                />
              </div>
              <div className="col-xxl-4 col-xl-4 col-lg-4 about-sec-col1 about-sec-col12 p-0">
                <div className="vision-box" data-aos="fade-up">
                  <img className="vision-icons" src={Mission} alt="mission" />
                  <h3 className="vision">Our Mission</h3>
                  <p className="sitamet-text sociis">
                    Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa cum sociis
                    natoque.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!-- ====================================== About Section Four ===================================== --> */}
        <section className="about-section-four">
          <div className="container">
            <div className="row about-section-four-row">
              <div className="col-xxl-6 col-xl-6 col-lg-6 reveal">
                <h2 className="section-heading-text" data-aos="fade-up">
                  <span>10 Years</span> Of Experience in Content Writing
                </h2>
                <p className="sitamet-text since" data-aos="fade-up">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Iusto blanditiis aliquam et modi amet eius perspiciatis ab
                  magni atque nesciunt?
                </p>
                <div
                  className="skill-bars aos-init aos-animate"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  <div className="progresbar-counter position-relative">
                    <h3 className="progress-title">Product Content</h3>
                    <div className="progress-value">
                      <span className="count c-counter" data-number="80">80</span>%
                    </div>
                    <div className="skil-progressbar" id="skil-progressbar1">
                      <span></span>
                    </div>
                  </div>
                  <div className="progresbar-counter position-relative">
                    <h3 className="progress-title">Website Content</h3>
                    <div className="progress-value">
                      <span className="count c-counter" data-number="70">70</span>%
                    </div>
                    <div className="skil-progressbar" id="skil-progressbar2">
                      <span></span>
                    </div>
                  </div>
                  <div className="progresbar-counter position-relative">
                    <h3 className="progress-title">Social Media Content</h3>
                    <div className="progress-value">
                      <span className="count c-counter" data-number="75">75</span>%
                    </div>
                    <div className="skil-progressbar" id="skil-progressbar3">
                      <span></span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-6 col-xl-6 col-lg-6 about-section-four-col1 overflow-hidden">
                <img className="about-img5" data-aos="fade-left" src={AboutImg5} alt="about-img5" />
              </div>
            </div>
          </div>
        </section>
        {/* <!-- ====================================== About Section Five ===================================== --> */}
        <ClientsSaySlider />
        {/* <!-- ====================================== About Section Six ===================================== --> */}
        <LatestBlog />
        {/* <!-- ====================================== About Section Seven ===================================== --> */}
        <section className="about-section-five">
          <div className="container">
            <h2 className="section-heading-text best-solutions" data-aos="fade-up">
              Trust Me to deliver the <span>best solutions</span> tailored to your needs.
            </h2>
            <p className="sitamet-text nemo-text" data-aos="fade-up">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Temporibus, iusto, quia neque amet saepe?
            </p>
            <div className="subscribe-input-main" data-aos="fade-up">
              <input type="text" placeholder="Enter Your Email" name='EntEmail' />
              <a href="#" className="button btn-subscribe" data-text="Subscribe">
                <span>Subscribe</span>
              </a>
            </div>
          </div>
        </section>
        {/* <!-- ====================================== About Section Seven ===================================== --> */}
        <Footer />
      </div>
    </>
  );
};

export default About;
